import { render, staticRenderFns } from "./tenantIndex.vue?vue&type=template&id=2c1aae03&"
import script from "./tenantIndex.vue?vue&type=script&lang=js&"
export * from "./tenantIndex.vue?vue&type=script&lang=js&"
import style0 from "./tenantIndex.vue?vue&type=style&index=0&id=2c1aae03&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports